import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.projects.views.ProjectListView.';

  public static readonly projectNumber = `${Id.prefix}projectNumber`;
  public static readonly projectTitle = `${Id.prefix}projectTitle`;
  public static readonly client = `${Id.prefix}client`;
  public static readonly author = `${Id.prefix}author`;
  public static readonly createProject = `${Id.prefix}createProject`;
  public static readonly cannotCreateProjectNotAssignedToBranch = `${Id.prefix}cannotCreateProjectNotAssignedToBranch`;
  public static readonly newProject = `${Id.prefix}newProject`;
  public static readonly active = `${Id.prefix}active`;
  public static readonly completed = `${Id.prefix}completed`;
  public static readonly cancelled = `${Id.prefix}cancelled`;
}

export class LangProjectListView {
  private constructor() {}

  public static projectNumber(): string {
    return interpolate(Id.projectNumber);
  }
  public static projectTitle(): string {
    return interpolate(Id.projectTitle);
  }
  public static client(): string {
    return interpolate(Id.client);
  }
  public static author(): string {
    return interpolate(Id.author);
  }
  public static createProject(): string {
    return interpolate(Id.createProject);
  }
  public static cannotCreateProjectNotAssignedToBranch(): string {
    return interpolate(Id.cannotCreateProjectNotAssignedToBranch);
  }
  public static newProject(): string {
    return interpolate(Id.newProject);
  }
  public static active(): string {
    return interpolate(Id.active);
  }
  public static completed(): string {
    return interpolate(Id.completed);
  }
  public static cancelled(): string {
    return interpolate(Id.cancelled);
  }
}

export class ProjectListViewModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.projectNumber, "{{glossary 'project'}} No.", 'Column header for project number');
    register.add(Id.projectTitle, "{{glossary 'project'}} Title", 'Column header for project title');
    register.add(Id.client, "{{glossary 'client'}}", 'Column header for client');
    register.add(Id.author, 'Author', 'Column header for author');
    register.add(Id.createProject, "Create {{glossary 'project'}}", 'Button label for creating a project');
    register.add(
      Id.cannotCreateProjectNotAssignedToBranch,
      "Cannot create {{glossary 'project'}} because you are not assigned to a {{glossary 'branch'}}, please contact support",
      'Error message for not being assigned to a branch'
    );
    register.add(Id.newProject, "New {{glossary 'project'}}", 'Default title for new project');
    register.add(Id.active, 'Active', 'Tab caption for active projects');
    register.add(Id.completed, 'Completed', 'Tab caption for completed projects');
    register.add(Id.cancelled, 'Cancelled', 'Tab caption for cancelled projects');
  }
}
